import { apiClient, extractData, extractList } from '../../lib/api-client.js';

export interface List {
  listId: string;
  userId: string;
  name: string;
  color: string;
  createdAt: number;
  updatedAt: number;
}

export async function fetchLists(): Promise<List[]> {
  const res = await apiClient.get('/v1/lists');
  return extractList<List>(res);
}

export async function createList(payload: { name: string; color?: string }): Promise<List> {
  const res = await apiClient.post('/v1/lists', payload);
  return extractData<List>(res);
}

export async function updateList(listId: string, payload: { name?: string; color?: string }): Promise<List> {
  const res = await apiClient.put(`/v1/lists/${listId}`, payload);
  return extractData<List>(res);
}

export async function deleteList(listId: string): Promise<void> {
  await apiClient.delete(`/v1/lists/${listId}`);
}
